import React, { useEffect, useState } from "react";
import { Btns, FormContainer } from "./styled";
import { Modal, Button, Input } from "antd";
import { SaveOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";
import { Method_POST_REST } from "../../../../../../../../service/api";

export function ModalAddCredencial({
  isOpen,
  onClose,
  atualizarTelaCredenciais,
  idClient,
}) {
  const [loadings, setLoadings] = useState(false);
  const [isIdCliente, setIsItCliente] = useState(null);

  const [newData, setNewData] = useState({
    codigo: "",
    id: "",
    senha: "",
    site: "",
    tipo: "",
  });

  useEffect(() => {
    setIsItCliente(idClient);
  });

  const cadastrarNovaCredencial = async () => {
    const url = "/cliente/empresa/credencial-acesso/adicional/cadastrar"; // baseURL já tá no service
    const param = {
      empresa: {
        id: isIdCliente,
      },
      codigo: newData.codigo,
      id: "",
      senha: newData.senha,
      site: newData.site,
      tipo: {
        id: newData.tipo,
      },
    };

    setLoadings(true);
    try {
      await Method_POST_REST(url, param);
      toast.success("Nova credencial adicionada.");
      await atualizarTelaCredenciais(idClient);
      onClose();
    } catch (error) {
      console.error("Erro no envio da credencial adicional:", error.message);
    } finally {
      setLoadings(false);
      clearForm();
    }
  };

  const handleChange = (field, value) => {
    setNewData((prev) => ({ ...prev, [field]: value }));
  };

  const clearForm = () => {
    setNewData({
      codigo: "",
      id: "",
      senha: "",
      site: "",
      tipo: "",
    });
  };

  return (
    <Modal
      title="Adicionar Credencial"
      open={isOpen}
      onCancel={() => {
        onClose();
        clearForm();
      }}
      footer={[
        <>
          <Btns>
            <Button
              key="cancel"
              onCancel={() => {
                onClose();
                clearForm();
              }}
            >
              Cancelar
            </Button>
            <Button
              className="btn"
              loading={loadings}
              onClick={cadastrarNovaCredencial}
            >
              <SaveOutlined /> Salvar
            </Button>
          </Btns>
        </>,
      ]}
    >
      <FormContainer>
        <div style={{ display: "flex" }}>
          <div className="form-content" style={{ display: "block", margin: 5 }}>
            <label>Tipo</label>
            <Input
              value={newData.tipo}
              onChange={(e) => handleChange("tipo", e.target.value)}
            />
          </div>

          <div className="form-content" style={{ display: "block", margin: 5 }}>
            <label>Código</label>
            <Input
              placeholder={newData.codigo}
              value={newData.codigo}
              onChange={(e) => handleChange("codigo", e.target.value)}
            />
          </div>
        </div>

        <div style={{ display: "flex" }}>
          <div className="form-content" style={{ display: "block", margin: 5 }}>
            <label>Senha</label>
            <Input.Password
              placeholder={newData.senha}
              value={newData.senha}
              onChange={(e) => handleChange("senha", e.target.value)}
            />
          </div>

          <div className="form-content" style={{ display: "block", margin: 5 }}>
            <label>Site</label>
            <Input
              placeholder={newData.site}
              value={newData.site}
              onChange={(e) => handleChange("site", e.target.value)}
            />
          </div>
        </div>
      </FormContainer>
    </Modal>
  );
}

export default ModalAddCredencial;
